export const en = {
    'client-features': 'Client features',
    'operator-features': 'Operator features'
};
